var React = require('react');

function CheckThinSm (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m14 .594-.719.688-7.281 7.281-3.281-3.281-.719-.688-1.406 1.406.688.719 4 4 .719.688.719-.688 8-8 .688-.719-1.406-1.406z","transform":"translate(0 1)"}));
}

CheckThinSm.defaultProps = {"viewBox":"0 0 16 16"};

module.exports = CheckThinSm;

CheckThinSm.default = CheckThinSm;
